import "./src/styles/bootstrap.scss"
import "./src/styles/customs.scss"
import "./src/styles/snipcart-customs.scss"
import "./node_modules/bootstrap/dist/js/bootstrap.js"
import "react-netlify-identity-widget/styles.css"